import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OCTOPUS_PETITION_SIGNER_RECEIPT_CONFIG = defineFcm('octopus_petition_signer_receipt_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				name: { type: 'string' },
				constraints: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
